itsoftApp.createModule("saveCookies", ["disclaimer"], function () {
    const saveCookieButtons = document.querySelectorAll(".js-save-button");
    const cookies = document.querySelector(".js-cookies");
    const bodyEnd = document.querySelector(".js-padding-bottom");
    const disclaimer = document.querySelector(".js-disclaimer");
    window.cookiesState = "inactive";

    const saveCookie = function (evt) {
        evt.preventDefault();

        const button = evt.currentTarget;

        if (button.hasAttribute("data-close")) {
            const plate = button.closest("[data-plate=" + button.getAttribute("data-close") + "]");

            plate && plate.classList.add("is-hidden");
        }

        itsoftApp.modules.cookie.setCookie(button);
        window.cookiesState = "inactive";
        bodyEnd.style.paddingBottom = 0;
        disclaimer.style.bottom = `0px`;
    }

    if (cookies && saveCookieButtons.length > 0 && !itsoftApp.modules.cookie.getCookie(cookies)) {
        window.cookiesState = "active";
        cookies.classList.remove('is-hidden');
        if (!itsoftApp.state.сheckListElementsToBeUpdatedDuringResizing.cookieHeight) {
            itsoftApp.state.сheckListElementsToBeUpdatedDuringResizing.cookieHeight = true;
            itsoftApp.calculations.cookieHeight = itsoftApp.utils.getCookieHeight();
        }
        bodyEnd.style.paddingBottom = itsoftApp.calculations.cookieHeight + "px";
        
        Array.prototype.forEach.call(saveCookieButtons, function (button) {
            button.addEventListener("click", saveCookie);
        });
    } else if (disclaimer) {
        disclaimer.style.bottom = `0px`;
    }
});